define('SageDotCom/Components/Pagination',[
    "Pagination",
    "underscore",
    "score_bootstrap/Utils/UrlHelper",
    "eventManager"
], function ($, _, urlHelper, eventManager) {
    function Pagination() {          
    }

    Pagination.prototype = Object.create(Pagination.prototype);

    Pagination.init = function (scope, underscoreTemplate, navigator, divToReplace, datasource, pageSize) {
            var $resultsTemplateDiv = $(divToReplace, scope);
            var resultsTemplate = _.template(underscoreTemplate); // generate an underscore template
            var lastPage = 1;

            var pageParam = urlHelper.getUrlParameters(window.location, "page");
            var hasPageParam = pageParam !== "undefined" && pageParam.length > 0;
            var pageNumQuery = 1;

            if (!isNaN(pageParam)) {
                pageNumQuery = parseInt(pageParam);
            }
         
            $('#pagination-container').pagination({
                dataSource: datasource,
                pageSize: pageSize,
                formatNavigator: '<div class=\'stats\'>' + navigator + '</div>',
                autoHidePrevious: true,
                autoHideNext: true,

                callback: function (data, pagination) {
                    var html = "";
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        html += resultsTemplate(item);
                    }

                    $resultsTemplateDiv.html(html);

                    var fromNumber = pagination.pageNumber * pagination.pageSize - (pagination.pageSize - 1);
                    var toNumber = data.length < pagination.pageSize ? pagination.totalNumber : pagination.pageNumber * pagination.pageSize;

                    if (toNumber !== 0) {
                        var paginationStatsLabel = navigator.replace("#", fromNumber + ' - ' + toNumber);
                        paginationStatsLabel = paginationStatsLabel.replace("##", pagination.totalNumber);
                        $(".stats", scope).html(paginationStatsLabel);
                    } else {
                        $(".stats", scope).html("");
                    }

                    if (pagination.pageNumber != lastPage) {
                        lastPage = pagination.pageNumber;
                        window.scroll(0, 0);
                    }

                    eventManager.trigger("add-aria-labels-to-pagination");
                },
                afterPageOnClick: function () {
                    updatePageNum();
                    eventManager.trigger("add-aria-labels-to-pagination");
                },
                afterPreviousOnClick: function () {
                    updatePageNum();
                    eventManager.trigger("add-aria-labels-to-pagination");
                },
                afterNextOnClick: function () {
                    updatePageNum();
                    eventManager.trigger("add-aria-labels-to-pagination");
                }
            });

            if (hasPageParam) {
                updateResults(pageNumQuery);
            } else if (history.pushState) {
                var query = window.location.search.length > 0 ? "&page=1" : "?page=1";
                var queryString = window.location.search + query;
                history.pushState("", "", queryString);
            }

            function updatePageNum() {
                var pageNum = $('#pagination-container').pagination('getSelectedPageNum');
                urlHelper.setUrlParameters(window.location, "page", pageNum);
                
                try {
                    var resourceCounterEl = $('[id^="intacctresourcescenterresults-"] .intacct-resources-listings .resources-count');
                    if (resourceCounterEl.length > 0) {
                        var showingValue = $('[id^="intacctresourcescenterresults-"] .intacct-resources').children().length;
                        var resourceCounterText = $(resourceCounterEl)[0].innerText;
                        resourceCounterText = resourceCounterText.replace($(resourceCounterEl).attr("results-show"),showingValue);
                        $(resourceCounterEl).attr("results-show", showingValue);
                        $(resourceCounterEl)[0].innerText = resourceCounterText;
                    }

                } catch(e) {}

                if (history.pushState) {
                    //get the query string re-assign page attr
                    var queryString = location.search;
                    if (queryString.indexOf("page=") !== -1) {
                        queryString = queryString.replace(/page=(\d+)/gi, "page=" + pageNum);
                    }
                    history.pushState("", "", queryString);
                }
            }

            function updateResults(page) {
                $('#pagination-container').pagination(page);
                urlHelper.setUrlParameters(window.location, "page", page);
            }

            return function init(args) {
                return args.IsExperienceEditorEditing ? null : new Pagination();
            };
        }

    return Pagination;
});
